<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Статусы контрагента</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"  @click.stop.native="showModal(null)" />
            </div>
          </div>
        </div>
      </div>
      <div class="page__table mb-20" v-if="statuses.length !== 0">
        <AppTable :data="statuses"
                  :headers="tableHeaders.headers"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeaders.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer page__footer_has-pagination">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active && roleAccessRemove"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти статусы?' : 'Вы действительно хотите удалить этот статус?'"
                       @confirm="removeConfirmation.group ? removeContractorsStatusGroup() : removeContractorsStatus()"
                       @reject="closeRemoveConfirmation"
      />
      <ContractorStatusModal v-if="modal.active && roleAccessEdit"
                             :state="modal"
                             @set-item-name="setContractorStatusItemName"
                             @clear-validation="clearModalValidation"
                             @save-item-info="saveContractorStatusItem"
                             @close-modal="closeModal"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractorStatusModal from '@/components/contractor/ContractorStatusModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppModal from '@/components/page/modal/AppModal'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractorsStatusList',
  components: {
    ContractorStatusModal,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppButtonSmRemove,
    AppModal,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractorStatusListPage', [
      'getContractorsStatusListTableHeaders',
      'getContractorsStatusList',
      'getContractorsStatusListModal',
      'getContractorsStatusListSearchValue',
      'getContractorsStatusListFilter',
      'getContractorsStatusListPagination',
      'getContractorsStatusListIsLoading',
      'getContractorsStatusListResponseModal',
      'getContractorsStatusListResponseModalWithTreaties',
      'getContractorsStatusListActiveDelete'
    ]),

    tableHeaders () {
      return this.getContractorsStatusListTableHeaders
    },
    statuses () {
      return this.getContractorsStatusList.map(status => {
        return ({
          id: status.id,
          isActive: status.isActive,
          values: [
            status.name
          ]
        })
      })
    },
    modal () {
      return this.getContractorsStatusListModal
    },
    searchValue () {
      return this.getContractorsStatusListSearchValue
    },
    filter () {
      return this.getContractorsStatusListFilter
    },
    pagination () {
      return this.getContractorsStatusListPagination
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isLoading () {
      return this.getContractorsStatusListIsLoading
    },
    deleteResponseModal () {
      return this.getContractorsStatusListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractorsStatusListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractorsStatusListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContractors.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContractors.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContractors.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('contractorStatusListPage/toggleContractorsStatusListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractorStatusListPage/toggleContractorsStatusListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractorStatusListPage/toggleContractorsStatusListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractorStatusListPage/showContractorsStatusModal', itemId)
    },
    setContractorStatusItemName (value) {
      this.$store.dispatch('contractorStatusListPage/setContractorsStatusItemName', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch('contractorStatusListPage/clearContractorsStatusModalValidation', inputName)
    },
    saveContractorStatusItem () {
      this.$store.dispatch('contractorStatusListPage/saveContractorsStatusItem')
    },
    closeModal () {
      this.$store.dispatch('contractorStatusListPage/closeContractorsStatusModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsStatus () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractorStatusListPage/removeContractorsStatus', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsStatusGroup () {
      this.$store.dispatch('contractorStatusListPage/deleteContractorsStatusListCheckedItems')
      this.removeConfirmation.active = false
      this.removeConfirmation.group = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    closeDeleteModal () {
      this.$store.dispatch('contractorStatusListPage/closeContractorsStatusListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractorStatusListPage/closeContractorsStatusListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractorStatusListPage/setContractorsStatusListSearchValue', value)
    },

    // filter

    // pagination
    togglePageList () {
      this.$store.dispatch('contractorStatusListPage/toggleContractorsStatusListPageList')
    },
    previousPage () {
      this.$store.dispatch('contractorStatusListPage/getContractorsStatusListPrevPage')
    },
    nextPage () {
      this.$store.dispatch('contractorStatusListPage/getContractorsStatusListNextPage')
    },
    getPage (pageNum) {
      this.$store.dispatch('contractorStatusListPage/getContractorsStatusListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractorStatusListPage/getContractorsStatus')
  },

  destroyed () {
    this.$store.commit('contractorStatusListPage/RESET_CONTRACTORS_STATUS_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
